import * as React from 'react';
import styles from './AboutTabSection.css';
import { UIHeading2 } from '@cian/ui-kit';

interface IProps {
  children: React.ReactNode;
  title: string;
  testId: string;
}

export const AboutTabSection = (props: IProps) => {
  const { children, testId, title } = props;

  return (
    <div className={styles['wrapper']} data-testid={testId}>
      <div className={styles['title']}>
        <UIHeading2>{title}</UIHeading2>
      </div>

      {children}
    </div>
  );
};
